import { Link, useParams } from "react-router-dom";
import { CatalogCta, CatalogHero, CatalogLayout, ProductGrid } from "../components/catalog";
import { getProduct } from "../data/products";
import { SOLUTIONS } from "../data/solutions";
import { NotFoundPage } from "./NotFoundPage";
export function SolutionDetailPage() {
  const { slug } = useParams();
  const t = SOLUTIONS.find((n) => n.slug === slug);
  if (t) {
    return (
      <CatalogLayout title={t.name} description={t.intro}>
        <CatalogHero label="Solutions" title={t.name} intro={t.intro} />
        <section className="catalog-wrap catalog-section catalog-first">
          <div className="catalog-two">
            <div>
              <h2>{t.heading}</h2>
              <p>{t.audience}</p>
              <ul className="catalog-checklist">
                {t.scenarios.map((n) => (
                  <li key={n}>{n}</li>
                ))}
              </ul>
            </div>
            <figure className="catalog-solution-image">
              <img src={t.image} alt={t.imageNote} />
              <figcaption>{t.imageNote}</figcaption>
            </figure>
          </div>
          <div className="catalog-two catalog-spaced">
            <article>
              <h3>Core setup</h3>
              <ul className="catalog-checklist">
                {t.baseline.map((n) => (
                  <li key={n}>{n}</li>
                ))}
              </ul>
            </article>
            <article>
              <h3>Optional modules</h3>
              <ul className="catalog-checklist">
                {t.optional.map((n) => (
                  <li key={n}>{n}</li>
                ))}
              </ul>
            </article>
          </div>
        </section>
        <section className="catalog-band">
          <div className="catalog-wrap catalog-section">
            <h2>What you receive</h2>
            <div className="catalog-features catalog-four">
              {t.deliverables.map(([n, r]) => (
                <article key={n}>
                  <h3>{n}</h3>
                  <p>{r}</p>
                </article>
              ))}
            </div>
            <div className="catalog-callout">
              <h3>Acceptance criteria</h3>
              <p>{t.acceptance}</p>
            </div>
          </div>
        </section>
        <section className="catalog-wrap catalog-section">
          <h2>Configure your system</h2>
          <ProductGrid products={t.products.map(getProduct).filter((n) => !!n)} />
          <p className="catalog-note">{t.boundary}</p>
        </section>
        {t.slug === "capture" && (
          <section className="catalog-wrap catalog-section">
            <h2>Data operations</h2>
            <p>Explore collection management, quality review and dataset delivery.</p>
            <Link className="catalog-text-link" to="/solutions/capture/data-platform">
              Data Platform →
            </Link>
          </section>
        )}
        {t.slug === "workstation" && (
          <section className="catalog-wrap catalog-section">
            <h2>Training and deployment</h2>
            <p>Plan compute, model integration and evaluation for your workstation.</p>
            <Link className="catalog-text-link" to="/training">
              Training & Compute →
            </Link>
          </section>
        )}
        <CatalogCta />
      </CatalogLayout>
    );
  } else {
    return <NotFoundPage />;
  }
}
